import { Autoplay, PerformanceMode } from '@cbsinteractive/avia-js';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
export class AbstractSTVPlatformConfig {
    configs;
    constructor(params) {
        this.configs = {
            playerOptions: {
                autoplay: Autoplay.ATTEMPT_UNMUTED,
                performanceMode: PerformanceMode.TV,
                renderTextTrackNatively: false
            },
            resourceConfig: {
                playback: {
                    enableAdvancedCodecs: true,
                    preferSpatialAudio: true
                }
            },
            properties: {
                device: EmbedDevice.UNKNOWN
            }
        };
        if (!params?.CONTENT?.isLive && this.configs?.resourceConfig?.playback?.abr?.capQualityToScreenSize) {
            this.configs.resourceConfig.playback.abr.capQualityToScreenSize = false;
        }
    }
    get utils() {
        return window?.SmartTag?.utilities;
    }
}
